var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.333,
    y: 0.667,
    width: 12,
    height: 12.667,
    rx: 1,
    fill: "#A8FFF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.667,
    y: 10.667,
    width: 12,
    height: 6.667,
    rx: 1,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.652 2.293c0-.162.13-.293.29-.293h10.435c.16 0 .29.131.29.293v11.734c0 .162-.13.293-.29.293H14.942a.292.292 0 01-.29-.293V2.293zm.58.294v11.146h9.855V2.587h-9.855z",
    fill: "#14454C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.623 3.76c.16 0 .29.131.29.293V16.08h10.725c.16 0 .29.131.29.293 0 .162-.13.294-.29.294H12.623a.292.292 0 01-.29-.294V4.053c0-.162.13-.293.29-.293z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.319 4.933c.16 0 .29.132.29.294 0 .162-.13.293-.29.293H16.68a.292.292 0 01-.29-.293c0-.162.13-.294.29-.294h4.638zM23.638 7.867c.16 0 .29.131.29.293 0 .162-.13.293-.29.293H16.68a.292.292 0 01-.29-.293c0-.162.13-.293.29-.293h6.957zM23.638 10.8c.16 0 .29.131.29.293 0 .162-.13.294-.29.294H16.68a.292.292 0 01-.29-.294c0-.162.13-.293.29-.293h6.957z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 8.667h11.334V16H14.333V8.667z",
    fill: "#14454C",
    fillOpacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-summary-291ae67d19953f9f3ae8743b8d57bd6e.svg";
export { SvgAiSummary as ReactComponent };